import React, { useState } from 'react';
import { ImageContent, MessageText } from './styled';
import { isValid } from 'date-fns';

const ChatImageWithLightbox = ({
  source,
  description,
  todasMensagens = [],
  LightboxComponent,
  typeFilter = ['image', 'sticker']
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const ensureDownloadParam = (rawUrl) => {
    if (!rawUrl) return rawUrl;
    try {
      if (rawUrl.indexOf('download=false') !== -1) {
        return rawUrl.replace('download=false', 'download=true');
      }
      const u = new URL(rawUrl, window.location.origin);
      if (u.searchParams.has('download')) {
        u.searchParams.set('download', 'true');
        return u.toString();
      }
      u.searchParams.append('download', 'true');
      return u.toString();
    } catch (e) {
      return (
        rawUrl + (rawUrl.includes('?') ? '&download=true' : '?download=true')
      );
    }
  };

  const isValidMediaUrl = (u) => {
    if (!u || typeof u !== 'string') return false;
    const trimmed = u.trim();
    return /^(https?:\/\/|\/\/|data:|blob:|data:image\/.+;base64,)/i.test(
      trimmed
    );
  };

  const handleImageClick = (e) => {
    e.stopPropagation();
    let imgs = [];

    if (Array.isArray(todasMensagens) && todasMensagens.length > 0) {
      imgs = todasMensagens
        .filter((m) => {
          const t = (m.response_type || m.type || '').toLowerCase();
          return typeFilter.includes(t);
        })
        .reduce((acc, imgs) => {
          const url = ensureDownloadParam(imgs.source || imgs.url || '');
          if (isValidMediaUrl(url)) acc.push(url);
          return acc;
        }, []);
    }

    if (imgs.length === 0) {
      imgs = Array.from(
        document.querySelectorAll('img[data-chat-image="true"]')
      ).reduce((acc, img) => {
        const url = ensureDownloadParam(img.src);
        if (isValidMediaUrl(url)) {
          acc.push(url);
        }
        return acc;
      }, []);
    }

    const normalizedSource = ensureDownloadParam(source);
    const idx = imgs.findIndex((s) => s === normalizedSource);
    setLightboxImages(imgs);
    setCurrentImageIndex(idx >= 0 ? idx : 0);
    setIsOpen(true);
  };

  const hasMultipleLightboxImages = lightboxImages.length > 1;
  const nextImageIndex = hasMultipleLightboxImages
    ? (currentImageIndex + 1) % lightboxImages.length
    : 0;
  const prevImageIndex = hasMultipleLightboxImages
    ? (currentImageIndex + lightboxImages.length - 1) % lightboxImages.length
    : 0;

  const handlePrev = () => setCurrentImageIndex(prevImageIndex);
  const handleNext = () => setCurrentImageIndex(nextImageIndex);
  const handleClose = () => setIsOpen(false);

  return (
    <div>
      <ImageContent>
        <img
          src={source}
          alt={description}
          data-chat-image="true"
          style={{ cursor: 'pointer', maxWidth: '100%' }}
          onClick={handleImageClick}
        />
        {isOpen && lightboxImages.length > 0 && LightboxComponent && (
          <LightboxComponent
            images={lightboxImages}
            index={currentImageIndex}
            onClose={handleClose}
            onPrev={handlePrev}
            onNext={handleNext}
            description={description}
          />
        )}
      </ImageContent>
      <MessageText>{description}</MessageText>
    </div>
  );
};

export default ChatImageWithLightbox;
